$(function(){
    $('.toggleTimer').click(function(e){
        e.preventDefault();

        let id = $(this).data('id');
        let inputValue = $(this).data('email');
        let active = $(this).data('active');

        if (active === 0) {
            Swal.fire({
                title: Lang.get('messages.email'),
                input: 'email',
                inputLabel: Lang.get('messages.confirm_email'),
                inputValue: inputValue,
                showCloseButton: true,
                showCancelButton: false,
                inputPlaceholder: Lang.get('messages.write_email')
            }).then(function(res) {
                if(res.isConfirmed && res.value.length){
                    toggleTimeControl(id, res.value);
                }
            });
        }else{
            Swal.fire({
                title: Lang.get('messages.sure_you_want_to_disable_employee'),
                showDenyButton: true,
                showCancelButton: false,
                confirmButtonText: 'Si',
                denyButtonText: 'No',
            }).then((result) => {
                if (result.isConfirmed) {
                    toggleTimeControl(id, '');
                }
            })
        }
    });

    $('a.showVideo').click(function(e){
        e.preventDefault();
        const lang = Lang.getLocale() === 'ca' ? 'cat' : 'esp';
        const version = $(e.target).data('version');
        Swal.fire({
            title: Lang.get('messages.get_started'),
            html: '<iframe class="tscplayer_inline" id="embeddedSmartPlayerInstance" src="/files/Video-es/Video-esp.html?embedIFrameId=embeddedSmartPlayerInstance" scrolling="no" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusCancel: false,
            focusDeny: false,
            focusConfirm: false,
            width: '990px'
        });
    });
    $('a.showExtended').click(function(e){
        e.preventDefault();
        Swal.fire({
            title: Lang.get('messages.advanced_video'),
            html: '<iframe class="tscplayer_inline" id="embeddedSmartPlayerInstance" src="/files/Extended-ca/Video.html?embedIFrameId=embeddedSmartPlayerInstance" scrolling="no" frameborder="0" webkitAllowFullScreen mozallowfullscreen allowFullScreen></iframe>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton: false,
            focusCancel: false,
            focusDeny: false,
            focusConfirm: false,
            width: '990px'
        });
    });
});

function toggleTimeControl(id, email){
    $.post("/ajax/time-control/toggle", {'employee_id': id, email: email}, function (json) {
        if (json.success === true) {
            Swal.fire({
                title: Lang.get('messages.action_completed'),
                html: json.message,
                icon: 'success',
                showCancelButton: false,
                confirmButtonText: 'OK',
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                }
            });
        } else {
            Swal.fire(
                Lang.get('messages.attention'),
                json.message,
                'warning'
            );
        }
    }, 'json');
}

$(document).on("click", '#btnDeleteAdmin', function(e){
    e.preventDefault();

    Swal.fire({
        title: Lang.get('messages.sure_you_want_to_change_the_admin'),
        icon: 'info',
        showCancelButton: false,
        confirmButtonText: 'OK',
    }).then((result) => {
        if (result.isConfirmed) {
            window.location.href = $(e.target).attr('href');
        }
    });
});
